import type { CustomImageOptions } from './CustomImage';

export const extractAlignValue = (
  classText: string,
): CustomImageOptions['align'] => {
  //* 가운데 정렬 class
  if (classText.includes('mx-auto')) return 'center';
  //* 오른쪽 정렬 class
  if (classText.includes('ml-auto')) return 'right';

  return 'left';
};
